import { MagnifyingGlassIcon } from "@phosphor-icons/react";
import type * as React from "react";
import { cn } from "@/lib/utils";

type PopoverSearchHeaderProps = Omit<
	React.ComponentProps<"input">,
	"onChange"
> & {
	ref?: React.Ref<HTMLInputElement>;
	onValueChange: (value: string) => void;
	showEnterHint?: boolean;
	wrapperClassName?: string;
};

function PopoverSearchHeader({
	ref,
	value,
	onValueChange,
	showEnterHint = false,
	wrapperClassName,
	className,
	placeholder,
	"aria-label": ariaLabel,
	...props
}: PopoverSearchHeaderProps) {
	return (
		<div
			className={cn(
				"flex items-center gap-2 border-b border-border/60 px-3 py-2.5",
				wrapperClassName,
			)}
		>
			<MagnifyingGlassIcon
				aria-hidden="true"
				className="size-4 shrink-0 text-muted-foreground"
			/>
			<input
				ref={ref}
				{...props}
				value={value ?? ""}
				onChange={(e) => onValueChange(e.target.value)}
				placeholder={placeholder}
				aria-label={ariaLabel ?? placeholder}
				className={cn(
					"flex-1 bg-transparent text-sm outline-none placeholder:text-muted-foreground",
					className,
				)}
			/>
			{showEnterHint && (
				<kbd className="hidden select-none rounded border border-border/60 bg-muted/60 px-1.5 py-0.5 text-[10px] font-medium text-muted-foreground sm:inline-block">
					↵
				</kbd>
			)}
		</div>
	);
}

export { PopoverSearchHeader };
